import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import { css } from '@emotion/react';
import ModalContainer from '@modals/ModalContainer';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

declare module '@stackflow/config' {
    interface Register {
        CouponDownloadModal: {};
    }
}

const CouponDownloadModal: ActivityComponentType<'CouponDownloadModal'> = () => {
    const { pop } = useFlow();
    const { t } = useTranslation('coupon');

    return (
        <Modal>
            <ModalContainer>
                <Column fullWidth spacing={32}>
                    <Column spacing={8} align='center' fullWidth>
                        <Text size='4xl' fontWeight='bold' align='center' css={textCss}>
                            {t('downloadModal.title')}
                        </Text>
                        <Text align='center' size='xl' css={textCss}>
                            {t('downloadModal.message')}
                        </Text>
                    </Column>
                    <Button fullWidth onClick={pop}>
                        {t('downloadModal.confirm')}
                    </Button>
                </Column>
            </ModalContainer>
        </Modal>
    );
};

const textCss = css`
    word-break: break-word;
`;

export default CouponDownloadModal;
